export default "__VITE_ASSET__gcxAo6Ap__"